import React, { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { ContainerStyled, CardStyled, TitleStyled } from './styled'
import { TState, TStatus } from '../../types'
import PendingLoan from './loanStatusTemplate/PendingLoan'
import ApprovedLoan from './loanStatusTemplate/ApprovedLoan'
import DeclinedLoan from './loanStatusTemplate/DeclinedLoan'

const statusMap: {[keyof in TStatus ]: ReactNode} = {
  hasPendingLoan: <PendingLoan />,
  hasApprovedLoan: <ApprovedLoan/>,
  hasDeclinedLoan: <DeclinedLoan/>
}

const RobertOwenLoanStatus = () => {
  const { state } = useLocation() as TState

  return (
    <ContainerStyled>
      <CardStyled>
        <TitleStyled>
          Hey
          {' '}
          {state?.borrowerName}
          ,
        </TitleStyled>
        {state?.currentStatus && statusMap[state?.currentStatus]}
      </CardStyled>
    </ContainerStyled>
  )
}

export default RobertOwenLoanStatus
